import _ from 'underscore';
import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Breadcrumbs } from '@bingads-webui-react/breadcrumbs';
import { StepsContext } from './index';

function getBreadcrumbItem(step) {
  return {
    key: step.path,
    text: step.title,
  };
}

export function StepBreadcrumbs(props) {
  const { initialItems } = props;
  const { steps } = useContext(StepsContext);

  const items = useMemo(() => {
    const ret = [...initialItems];

    // traverse the steps tree to find the currently selected step
    let found = false;
    let currentArray = steps || [];
    let index = 0;
    while (!found && index < currentArray.length) {
      const step = currentArray[index];

      if (step.containsSelected) {
        // go down 1 level in the tree
        ret.push(getBreadcrumbItem(step));
        currentArray = step.steps;
        index = 0;
      } else {
        if (step.isSelected) {
          ret.push(getBreadcrumbItem(step));
          found = true;
        }
        index += 1;
      }
    }

    return ret;
  }, [initialItems, steps]);

  // any additional props will be passed through to the <Breadcrumbs /> component
  const breadcrumbsProps = {
    ..._.omit(props, initialItems),
    items,
  };

  return (
    <Breadcrumbs {...breadcrumbsProps} />
  );
}

StepBreadcrumbs.propTypes = {
  initialItems: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
  })),
};

StepBreadcrumbs.defaultProps = {
  initialItems: [],
};
